import React from 'react';
import { withTranslation } from 'react-i18next';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  CustomInput,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { remove } from 'lodash';

const disableBehaviors = [
  { label: 'Data Acquisition', value: 1 },
  { label: 'Logging', value: 0 },
  { label: 'Alarm Processing', value: 2 },
];
const DModal = ({ isOpen, t, ...props }) => {
  const [form, setForm] = React.useState({
    effectiveDate: new Date(),
    disableSensorBehaviors: [],
  });
  const onSelect = (e, behaviorValue) => {
    const behaviorArr = form.disableSensorBehaviors;
    if (e.target.checked) {
      behaviorArr.push(behaviorValue);
    } else {
      remove(behaviorArr, (behavior) => behavior === behaviorValue);
    }
    setForm({ ...form, disableSensorBehaviors: behaviorArr });
  };
  React.useEffect(() => {
    setForm({
      effectiveDate: new Date(),
      disableSensorBehaviors: [],
    });
  }, [isOpen]);
  return (
    <Modal isOpen={isOpen} className={props.className} fade={false}>
      <ModalHeader>
        <i className="md-icon" style={{ marginRight: 10 }}>
          sync_disabled
        </i>
        <span style={{ verticalAlign: 'text-bottom' }}>
          {t('Disable sensor(s)')}
        </span>
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label htmlFor="effectiveDate">
              {t('Disable Sensor(s) Until')}
            </Label>
            <DatePicker
              id="effectiveDate"
              className="form-control"
              selected={form.effectiveDate}
              onChange={(date) => setForm({ ...form, effectiveDate: date })}
              popperClassName="z-99"
              showTimeSelect
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="MM/dd/yyyy H:mm"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="disableSensorBehaviors">
              {t('Disable Behavior(s)')}
            </Label>
            {disableBehaviors.map((behavior, index) => (
              <CustomInput
                key={index}
                type="checkbox"
                id={behavior.label}
                checked={form.disableSensorBehaviors.includes(behavior.value)}
                label={t(behavior.label)}
                onChange={(e) => onSelect(e, behavior.value)}
              />
            ))}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="default" onClick={props.onCancel}>
          {t('Cancel')}
        </Button>
        <Button color="primary" onClick={() => props.onConfirm(form)}>
          {t('Disable')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const EModal = ({ isOpen, t, ...props }) => {
  // const [dateTime, setDateTime] = React.useState(new Date());
  return (
    <Modal isOpen={isOpen} className={props.className} fade={false}>
      <ModalHeader>
        <i className="md-icon" style={{ marginRight: 10 }}>
          sync
        </i>
        <span style={{ verticalAlign: 'text-bottom' }}>
          {t('Enable sensor(s)')}
        </span>
      </ModalHeader>
      {/* <ModalBody>
        <Form>
          <FormGroup>
            <Label htmlFor="dateTime">{t('Enable Sensor(s) From')}</Label>
            <DatePicker
              id="dateTime"
              className="form-control"
              selected={dateTime}
              onChange={(date) => setDateTime(date)}
              showTimeSelect
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="MM/dd/yyyy H:mm"
            />
          </FormGroup>
        </Form>
      </ModalBody> */}
      <ModalFooter>
        <Button color="default" onClick={props.onCancel}>
          {t('Cancel')}
        </Button>
        <Button color="primary" onClick={() => props.onConfirm()}>
          {t('Enable')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export const DisableModal = withTranslation('app')(DModal);
export const EnableModal = withTranslation('app')(EModal);
